import Handlebars from 'handlebars';
import '../handlebars_helpers';

Handlebars.getTemplate = (name) => {
  if (typeof Handlebars.templates == 'undefined') {
    Handlebars.templates = {};
  }

  if (!Handlebars.templates[name]) {
    Handlebars.templates[name] = Handlebars.compile($(name).html());
  }

  return Handlebars.templates[name];
};

export default Handlebars;
